import {
  type EMethodosEntity,
  type EMethodosInputEntity,
  EMethodosSchema
} from '@/core/infrastructure/schemas/emethodos/EMethodosSchema.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'

export default class EMethodos {
  readonly id: number
  readonly title: string
  readonly url: string
  readonly thumbnail: string
  readonly order: number
  readonly visible: boolean
  readonly tags: string[]

  constructor(eMethodos: EMethodosEntity) {
    this.id = eMethodos.id
    this.title = eMethodos.title
    this.url = eMethodos.url
    this.thumbnail = eMethodos.thumbnail
    this.order = eMethodos.order
    this.visible = eMethodos.visible
    this.tags = eMethodos.tags
  }

  get eMethodos() {
    return {
      id: this.id,
      title: this.title,
      url: this.url,
      thumbnail: this.thumbnail,
      order: this.order,
      visible: this.visible,
      tags: this.tags
    }
  }

  public static create(data: unknown): EMethodos {
    return EntityValidator.validateAndCreate(EMethodosSchema, data, EMethodos, 'EMethodos')
  }

  toInput(): EMethodosInput {
    return new EMethodosInput({
      id: this.id,
      title: this.title,
      url: this.url,
      thumbnail: this.thumbnail,
      order: this.order,
      visible: this.visible,
      tags: this.tags
    })
  }
}

export class EMethodosInput {
  readonly id: number
  readonly title: string
  readonly url: string
  readonly thumbnail: string
  readonly order: number
  readonly visible: boolean
  readonly tags: string[]

  constructor(eMethodos: EMethodosInputEntity) {
    this.id = eMethodos.id
    this.title = eMethodos.title
    this.url = eMethodos.url
    this.thumbnail = eMethodos.thumbnail
    this.order = eMethodos.order
    this.visible = eMethodos.visible
    this.tags = eMethodos.tags
  }
}
